<template>
  <div class="requestshipment">
    <div v-if="$route.params.step !== stepName">
       <FreightMode @inputData="postData" />
    </div>
    <div v-else class="requestshipment__container">
      <div class="tabs__model2">
        <b-card no-body>
          <b-tabs v-model="tabIndex" content-class="mt-3" justified>
            <b-tab :active="item.id === 1"
                   :title-item-class="disabledTab(item.id)"
                   :title-link-class="linkClass(item.id)"
                   v-for="(item, idx) in steps" :key="item.id">
              <template #title>
                <h1 class="mytitle">{{item.title}}</h1>
                <p class="mysubtitle">{{item.subtitle}}</p>
              </template>
              <component v-bind:is="CurrentStepComponent(idx)"
                         @tabIndex="ButtonNext"
                         @tabIndexPrev="ButtonPrev"
                         @chgHeader="setHeader"
                         @inputData="postData"
                         @errorInput="errorInput"
                         :outputData="data"
                         :showError="showError"
                         :showErrorShipmentDate="showErrorShipmentDate"
                         :showErrorProductType="showErrorProductType"
                         :showErrorDestination="showErrorDestination"
                         :showErrorPricing="showErrorPricing"
                         >
              </component>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import FreightMode from '@/components/contract/FreightMode'
import ShipmentAir from '@/components/contract/ShipmentAir'
import ShipmentOcean from '@/components/contract/ShipmentOcean'
import ProductType from '@/components/contract/ProductType'
import Destination from '@/components/contract/Destination'
import ShipmentDate from '@/components/contract/ShipmentDate'
import PricingAdditional from '@/components/contract/PricingAdditional'
import mixin from '@/mixin'
import ModalCreateShipment from '@/components/global/modals/CreateShipment'

export default {
  name: 'Contract',
  components: {
    FreightMode,
    ShipmentAir,
    ShipmentOcean,
    ProductType,
    Destination,
    ShipmentDate,
    PricingAdditional,
    ModalCreateShipment
  },
  mixins: [mixin],
  data () {
    return {
      stepName: 'type-shipment',
      tabIndex: 1,
      data: {},
      errorData: false,
      selectedtabs: FreightMode,
      selectedstep: 1,
      isActive: true,

      // selectedstep: 1,
      // showModal1: false,
      // isHidden: false,
      // data: {},
      // form: {},
      steps: [
        {
          id: 1,
          title: 'SHIPMENT TYPE',
          subtitle: 'Choose your shipment type',
          content: ShipmentOcean,
          isDisable: false,
          status: true
        },
        {
          id: 2,
          title: 'PRODUCT TYPE',
          subtitle: 'Choose your product type',
          content: ProductType,
          isDisable: true,
          status: false
        },
        {
          id: 3,
          title: 'SHIPMENT DATE & ROUTE',
          subtitle: 'Choose your shipment date & route',
          content: ShipmentDate,
          status: false
        },
        {
          id: 4,
          title: 'ADDITIONAL',
          subtitle: 'Set your budget & add service',
          content: PricingAdditional,
          isDisable: true,
          status: false
        }
      ],
      showError: false,
      showErrorShipmentDate: false,
      showErrorProductType: false,
      showErrorDestination: false,
      showErrorPricing: false,
      checkErrorStat: 'check',
      payloadLog: {
        featureName: 'CREATE CONTRACT',
        featureStep: 1,
        stepName: 'Contract Duration',
        featureProcess: {
          status: 'success',
          data: {}
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/profile',
      authError: 'auth/error',
      authIsLoading: 'auth/isLoading',
      // contact
      contractCreated: 'contract/obj',
      contractError: 'contract/error'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let temp = this.data
      let auth = this.auth

      if (auth) {
        temp.customer_company_name = auth.companyName
        temp.customer_company_address = auth.companyAddress
        temp.customer_email = auth.customerEmail
        temp.customer_name = auth.customerName
        temp.customer_phone = auth.customerPhone

        this.auth && Object.assign(this.data, temp)
      }
      // insert log
      this.payloadLog.featureProcess.data = this.data
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },

    disabledTab (idx) {
      if (this.tabIndex < idx) {
        return 'disabledTab'
      } else {
        return ''
      }
    },
    linkClass (idx) {
      if (this.tabIndex < idx) {
        return ['', ''] // return default
      } else {
        return ['bg-primary-blue', 'text-white']
      }
    },

    CurrentStepComponent (idx) {
      this.checkRoute()
      return this.steps[idx].content
    },

    checkRoute () {
      if (this.$route.query && this.$route.query.mode) {
        if (this.$route.query.mode === 'AIR') {
          this.steps[0].content = ShipmentAir
        } else if (this.$route.query.mode === 'OCEAN') {
          this.steps[0].content = ShipmentOcean
        }
      } else {
        this.$router.push({name: 'RequestShipmentContract'})
      }
    },

    setHeader (data) {
      this.steps[data.id - 1].subtitle = data.subtitle
    },

    postData (payload) {
      if (payload.typeObj && payload.typeObj === 'sub') {
        Object.assign(this.form, payload)
      } else {
        Object.assign(this.data, payload)
      }
    },

    errorInput (payload) {
      Object.assign(this.errorData, payload)
    },

    createLog (step, name, data, status) {
      const payload = {
        featureStep: step,
        stepName: name,
        featureProcess: {
          status: status,
          data: data
        }
      }
      this.$store.dispatch('log/CREATE_LOG', payload)
    },

    ButtonNext () {
      if (this.tabIndex === 0) {
        this.tabIndex += 1
        this.createLog(1, 'Shipment Type', this.data, 'success')
      } else if (this.tabIndex === 1) {
        this.tabIndex += 1
        this.createLog(2, 'Product Type', this.data, 'success')
      } else if (this.tabIndex === 2) {
        this.tabIndex += 1
        this.createLog(3, 'Shipment Data & Route', this.data, 'success')
      } else if (this.tabIndex === 3) {
        this.submitCreateShipmet()
        this.createLog(4, 'Additional', this.data, 'success')
      }
    },

    submitCreateShipmet () {
      this.data.form = this.form
      const formData = new FormData()

      formData.append('fileDocument', this.data.fileDocument)

      // cust data
      formData.append('customer_company_name', this.data.customer_company_name)
      formData.append('customer_company_address', this.data.customer_company_address)
      formData.append('customer_email', this.data.customer_email)
      formData.append('customer_name', this.data.customer_name)
      formData.append('customer_phone', this.data.customer_phone)

      // duratiom
      formData.append('duration_start', this.data.duration_start)
      formData.append('duration_finish', this.data.duration_finish)

      // freight / shipment type
      formData.append('service_head', this.data.service_head)
      formData.append('shipment_type', this.data.shipment_type)
      formData.append('service_sub_type', this.data.service_sub_type)
      formData.append('satuan', this.data.satuan)
      formData.append('total_container', this.data.total_container)
      formData.append('total_container_per_month', this.data.total_container_per_month)
      formData.append('temperature', this.data.temperature ? this.data.temperature : 0)
      formData.append('total_weight', this.data.total_weight)
      formData.append('totalshipment', this.data.totalshipment)
      formData.append('estimateddimention', this.data.estimateddimention)
      formData.append('total_quantity', this.data.total_quantity)
      formData.append('lengthdimension', this.data.lengthdimension)
      formData.append('widthdimension', this.data.widthdimension)
      formData.append('heightdimension', this.data.heightdimension)
      formData.append('container_option', this.data.container_option ? this.data.container_option : '')
      formData.append('weight_estimation', this.data.weight_estimation ? parseFloat(this.data.weight_estimation, 10) : 0)

      // product type
      formData.append('commoditiesClass', this.data.commoditiesClass)
      formData.append('product_type', this.data.product_type)
      formData.append('description', this.data.description)
      formData.append('productDescription', this.data.productDescription)
      formData.append('total_price', this.data.total_price)
      formData.append('hs_code', this.data.hs_code)
      formData.append('un_number', this.data.un_number ? this.data.un_number : '')

      // route
      formData.append('originArea', this.data.originArea)
      formData.append('destinationArea', this.data.destinationArea)
      formData.append('country_from', this.data.country_from)
      formData.append('country_to', this.data.country_to)
      formData.append('city_from', this.data.city_from)
      formData.append('city_to', this.data.city_to)
      formData.append('delivery_address_ori', this.data.delivery_address_ori)
      formData.append('delivery_address_desti', this.data.delivery_address_desti)
      formData.append('optiontp', this.data.optiontp)

      // pricing & additional
      formData.append('option_insurance', this.data.option_insurance)
      formData.append('insuranceId', this.data.insuranceId)
      formData.append('option_customs_clearance', this.data.option_customs_clearance)
      formData.append('option_customs_clearance_destination', this.data.option_customs_clearance_destination)
      formData.append('option_estimate_storage', this.data.option_estimate_storage)
      formData.append('request_rate', this.data.request_rate)
      formData.append('request_rate_to', this.data.request_rate_to)
      formData.append('paymentReferences', this.data.paymentReferences)
      formData.append('note_for_merchant', this.data.note_for_merchant)
      
      this.$store.dispatch('contract/CREATE_CONTRACT', formData)
    },

    ButtonPrev () {
      if (this.tabIndex === 4) {
        this.tabIndex -= 1
      } else if (this.tabIndex === 3) {
        this.tabIndex -= 1
        this.createLog(2, 'Product Type', this.data)
      } else if (this.tabIndex === 2) {
        this.tabIndex -= 1
      } else if (this.tabIndex === 1) {
        this.tabIndex -= 1
      } else if (this.tabIndex === 0) {
        this.$eventHub.$emit('dialog-request-leave')
      }
    },

    checkDuration (from, to) {
      let status = true
      const dateDefauld = 'YYYY/MM/DD'
      const dateFrom = moment([moment(from, dateDefauld).year(), moment(from, dateDefauld).month(), moment(from, dateDefauld).date()])
      const dateTo = moment([moment(to, dateDefauld).year(), moment(to, dateDefauld).month(), moment(to, dateDefauld).date()])
      const different = dateTo.diff(dateFrom, 'days')
      if (different < 90 || different > 365) {
        status = false
      }
      return status
    }
  },
  watch: {
    contractCreated (data) {
      if (data) {
        // insert log
        this.createLog(4, 'Submit CTC', this.data, 'success')
        this.$eventHub.$emit('dialog-contract-pricing')
      }
    },
    contractError (data) {
      if (data) {
        // insert log
        this.createLog(4, 'Submit CTC', this.data, 'failed')
        this.$eventHub.$emit('dialog-error-create-quotation', data.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/requestShipmentContract/index.vue